var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bs-wrapper communication"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }